// Delimiters that separate meaningful fragments inside a path-based tracking
// link. Kept in a capturing group so `split` preserves them in the result.
export const PATH_SEGMENT_DELIMITERS = /([/#&=?])/

export interface ITokenizedPathUrl {
  origin: string
  tokens: string[]
}

// Splits a URL into its origin plus a token list where even indices are text
// fragments and odd indices are the captured delimiters (/ # & = ?).
// Returns null for malformed URLs.
export const tokenizePathUrl = (url: string): ITokenizedPathUrl | null => {
  try {
    const urlObj = new URL(url)

    return {
      origin: urlObj.origin,
      tokens: (urlObj.pathname + urlObj.search + urlObj.hash).split(PATH_SEGMENT_DELIMITERS),
    }
  } catch {
    return null
  }
}

// Non-empty fragments between delimiters, in left-to-right order.
// e.g. https://brand.com/awin/af123#sub456 → ['awin', 'af123', 'sub456']
export const extractPathSegments = (url: string): string[] => {
  const parsed = tokenizePathUrl(url)
  if (!parsed) return []

  return parsed.tokens.filter((_, index) => index % 2 === 0).filter(Boolean)
}
